import { createCollection, localStorageCollectionOptions } from "@tanstack/react-db";
import type { Script } from "../script";

export const scriptsCollection = createCollection(
  localStorageCollectionOptions<Script>({
    storageKey: "camera-scanner-scripts",
    getKey: script => script.id,
    // Same reason as pagesCollection: the upload queue resolves a page's
    // script outside React, before anything has subscribed.
    startSync: true,
  }),
);
